import React from "react";

const STATUS_MAP = {
  draft: { label: "DRAFT", cls: "text-slate-400 bg-slate-400/10 border-slate-400/20" },
  manifest_generating: { label: "GENERATING…", cls: "text-blue-400 bg-blue-400/10 border-blue-400/20" },
  manifest_review: { label: "IN REVIEW", cls: "text-amber-400 bg-amber-400/10 border-amber-400/20" },
  locked: { label: "LOCKED", cls: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS_MAP[status] || STATUS_MAP.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-sm border ${s.cls} ${className}`}
    >
      {s.label}
    </span>
  );
}
